<template>
  <div class="surplus">
    <custom-plane
      :title="`${'剩余车位'}${'(' + clickData + ')'}`"
      :iconImg="require('@/assets/compImg/parking/parking.png')"
    >
      <div class="parkData">
        <span>{{ (count[clickData] || "").split("/", 1).join() }}</span
        ><span>&nbsp;/&nbsp;</span>
        <span class="after">{{ (count[clickData] || "").split("/")[1] }}</span>
      </div>
      <div class="progress">
        <div class="level">
          <div class="cont">剩余</div>
          <div class="cont">总量</div>
        </div>
        <div style="width:376px">
          <custom-progress-heightline
            :value="
              surplusValue ||
                (Number((count[clickData] || '').split('/', 1).join()) /
                  Number((count[clickData] || '').split('/')[1])) *
                  100
            "
            :splitCount="40"
          ></custom-progress-heightline>
        </div>
        <!-- <div class="clickdata">
                    <custom-frame :shareList="shareList" @surplusData="surplusData"></custom-frame>
                </div> -->
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  data() {
    return {
      surplusValue: "",
    };
  },
  props: {
    count: Object,
    clickData: String,
  },
  watch: {
    clickData: {
      handler(newval) {
        this.surplusValue =
          (Number(this.count[newval].split("/")[0]) /
            Number(this.count[newval].split("/")[1])) *
          100;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.surplus {
  width: 416px;
  height: 165px;
  margin-top: 20px;

  .parkData {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      font-family: "dina";
      font-weight: 500;
      font-size: 36px;
    }

    .after {
      color: rgba(255, 255, 255, 0.7);
    }
  }

  .progress {
    padding: 0 20px;
    .level {
      display: flex;
      justify-content: space-between;
      margin-bottom: 4px;

      .cont {
        font-size: 16px;
        letter-spacing: 0.1em;
      }
    }
  }
}
</style>
